import { render, staticRenderFns } from "./JobLists.vue?vue&type=template&id=54896daa&scoped=true&"
import script from "./JobLists.vue?vue&type=script&lang=js&"
export * from "./JobLists.vue?vue&type=script&lang=js&"
import style0 from "./JobLists.vue?vue&type=style&index=0&id=54896daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54896daa",
  null
  
)

export default component.exports